export const categories = [
  {
    name: 'Home & Decor',
    image: 'https://i.pinimg.com/736x/49/33/b8/4933b84e2b9c209425645da30fbe1bf6.jpg',
  },
  {
    name: 'Fashion & Style',
    image: 'https://i.pinimg.com/736x/8a/db/ca/8adbca281bc3cfbf331ffd76a9933a90.jpg',
  },
  {
    name: 'Food & Recipes',
    image: 'https://i.pinimg.com/736x/9d/fc/4c/9dfc4c95c53261d1bc576f66ba52fef6.jpg',
  },
  {
    name: 'Beauty',
    image: 'https://i.pinimg.com/736x/03/13/ec/0313ec64713964af1ffdc5bddcce68c1.jpg',
  },
  {
    name: 'Travel',
    image: 'https://i.pinimg.com/736x/09/3d/2c/093d2cfc19371df937817930112f3db2.jpg',
  },
  {
    name: 'Art & Design',
    image: 'https://i.pinimg.com/1200x/0f/28/e2/0f28e2f3ba6458e7b3cfe604788eabae.jpg',
  },
  {
    name: 'Health & Wellness',
    image: 'https://i.pinimg.com/736x/57/48/fa/5748fa864ae531fed05b5f6e160fd048.jpg',
  },
  {
    name: 'Weddings & Events',
    image: 'https://i.pinimg.com/736x/83/cd/ab/83cdab50d8b0fb6c8a08916de61b9d82.jpg',
  },
  {
    name: 'DIY & Crafts',
    image: 'https://i.pinimg.com/736x/e9/88/91/e98891b1075ed18380da99c9d6191888.jpg',
  },
  {
    name: 'Education & Learning',
    image: 'https://i.pinimg.com/736x/75/91/01/759101888b02cb37f3c079522dd29125.jpg',
  },
  {
    name: 'Fitness & Sports',
    image: 'https://i.pinimg.com/736x/f9/a7/a3/f9a7a30e3f6cada77cbd30f47f5a430f.jpg',
  },
  {
    name: 'Gardening & Nature',
    image: 'https://i.pinimg.com/736x/0d/5d/98/0d5d9821fecc271b0efbd0a1f3a13346.jpg',
  },
  {
    name: 'others',
    image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
  },
];

export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
  image{
    asset->{
      url
    }
  },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;

export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title, 
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const pinDetailMorePinQuery = (pin) => {
  const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const searchQuery = (searchTerm) => {
  const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
        image{
          asset->{
            url
          }
        },
            _id,
            destination,
            postedBy->{
              _id,
              userName,
              image
            },
            save[]{
              _key,
              postedBy->{
                _id,
                userName,
                image
              },
            },
          }`;
  return query;
};

export const userQuery = (userId) => {
  const query = `*[_type == "user" && _id == '${userId}']`;
  return query;
};

export const userCreatedPinsQuery = (userId) => {
  const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};

export const userSavedPinsQuery = (userId) => {
  const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
    _id,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
    save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
  }`;
  return query;
};
